<template>
    <dl>
        <dt v-if="firmAttributes.name && displayName">
            Name
        </dt>
        <dd v-if="firmAttributes.name && displayName">
            {{ firmAttributes.name }}
        </dd>

        <dt v-if="firmAttributes.nameAffix">
            Name Zusatz
        </dt>
        <dd v-if="firmAttributes.nameAffix">
            {{ firmAttributes.nameAffix }}
        </dd>

        <dt v-if="firmAttributes.street">
            Straße
        </dt>
        <dd v-if="firmAttributes.street">
            {{ firmAttributes.street }}
        </dd>

        <dt v-if="firmAttributes.city && firmAttributes.postalCode">
            Ort
        </dt>
        <dd v-if="firmAttributes.city && firmAttributes.postalCode">
            {{ firmAttributes.postalCode }}
            {{ firmAttributes.city }}
        </dd>

        <dt v-if="firmAttributes.phone">
            Telefon
        </dt>
        <dd v-if="firmAttributes.phone">
            <a :href="'tel://' + firmAttributes.phone">{{ firmAttributes.phone }}</a>
        </dd>

        <dt v-if="firmAttributes.mobile">
            Mobil
        </dt>
        <dd v-if="firmAttributes.mobile">
            <a :href="'tel://' + firmAttributes.mobile">{{ firmAttributes.mobile }}</a>
        </dd>

        <dt v-if="firmAttributes.email">
            Email
        </dt>
        <dd v-if="firmAttributes.email">
            <a :href="'mailto:' + firmAttributes.email">{{ firmAttributes.email }}</a>
        </dd>

        <slot/>
    </dl>
</template>

<script>
    export default {
        props: {
            displayName: {
                type: Boolean,
                default: false,
            },
            firmAttributes: {
                type: Object,
                required: true,
            },
        },
    }
</script>
